var DialogData = /** @class */ (function () {
    function DialogData() {
    }
    return DialogData;
}());
export { DialogData };
//# sourceMappingURL=dialogData.js.map